import { eventTypeStandard, getPageType } from './internal/core';
import { pushWithGlobalSale } from './internal/pushWithGlobal';

import { isAuction } from '~/types/sale.type';

export type UseTrackingNegotiationReturn = {
    trackDsNegotiationStartNegotiation: VoidFunction;
    trackNegotiationGoToNegotiation: (linkText: 'go_negotiation' | 'show_negotiation') => void;
    trackNegotiationOpenUpdateProposalModal: (isBuyer: boolean) => void;
    trackNegotiationOpenAcceptModal: (isBuyer: boolean) => void;
    trackNegotiationOpenSellerDeclineModal: VoidFunction;
    trackNegotiationAccept: (isBuyer: boolean, amount: number) => void;
};

export const useTrackingNegotiation = (): UseTrackingNegotiationReturn => ({
    trackDsNegotiationStartNegotiation(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: 'make_offer',
            page_type: getPageType(),
            sales,
            ...eventTypeStandard,
        }));
    },

    trackNegotiationGoToNegotiation(clickText): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: clickText,
            page_type: getPageType(),
            sales,
            ...eventTypeStandard,
        }));
    },

    trackNegotiationOpenUpdateProposalModal(isBuyer): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: isBuyer ? 'change_offer' : 'change_ask',
            page_type: getPageType(),
            sales,
            ...eventTypeStandard,
        }));
    },

    trackNegotiationOpenAcceptModal(isBuyer): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: isBuyer ? 'accept_ask' : 'accept_offer',
            page_type: getPageType(),
            sales,
            ...eventTypeStandard,
        }));
    },

    trackNegotiationOpenSellerDeclineModal(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: 'end_negotiation',
            page_type: getPageType(),
            sales,
            ...eventTypeStandard,
        }));
    },

    trackNegotiationAccept(isBuyer, amount): void {
        pushWithGlobalSale(
            (sales, sale): Record<string, any> => {
                const buyerClickText = isAuction(sale) ? 'accept_ask' : 'accept_request';
                const clickText = isBuyer ? buyerClickText : 'accept_offer';

                const buyerPageType = isAuction(sale) ? 'negotiation_accept_ask' : 'negotiation_accept_request';
                const pageType = isBuyer ? buyerPageType : 'negotiation_accept_offer';

                return {
                    event: 'click',
                    click_element: 'button',
                    click_text: clickText,
                    page_type: pageType,
                    sales,
                    ...eventTypeStandard,
                };
            },
            { value: amount }
        );
    },
});
